/**
 * Adaptive Points Plugin for uPlot
 * Shows points only when zoomed in enough AND enabled
 */

import uPlot from "uplot";
import { countVisiblePoints } from '../utils';
import { POINT_VISIBILITY_THRESHOLD } from '../constants';

export function adaptivePointsPlugin(
  showPointsRef: { current: boolean },
  enabledRef: { current: boolean }
) {
  let lastShowPoints: boolean | null = null;

  return {
    hooks: {
      ready: [
        (u: uPlot) => {
          const timestamps = u.data[0] as number[];
          if (!timestamps || timestamps.length === 0) return;

          const xMin = u.scales.x.min ?? timestamps[0];
          const xMax = u.scales.x.max ?? timestamps[timestamps.length - 1];
          const visibleCount = countVisiblePoints(timestamps, xMin, xMax);
          const shouldShowPoints = visibleCount <= POINT_VISIBILITY_THRESHOLD && enabledRef.current;

          lastShowPoints = shouldShowPoints;
          showPointsRef.current = shouldShowPoints;
        },
      ],
      setScale: [
        (u: uPlot, scaleKey: string) => {
          if (scaleKey !== "x") return;

          const timestamps = u.data[0] as number[];
          if (!timestamps || timestamps.length === 0) return;

          const xMin = u.scales.x.min ?? timestamps[0];
          const xMax = u.scales.x.max ?? timestamps[timestamps.length - 1];
          const visibleCount = countVisiblePoints(timestamps, xMin, xMax);
          const shouldShowPoints = visibleCount <= POINT_VISIBILITY_THRESHOLD && enabledRef.current;

          if (shouldShowPoints !== lastShowPoints) {
            lastShowPoints = shouldShowPoints;
            showPointsRef.current = shouldShowPoints;
            u.redraw();
          }
        },
      ],
    },
  };
}
